/**
 * Apartsales — Tab 5 (Паспорт собственника).
 *
 * Phase 1 minimal: до первой сделки этот таб — settings hub.
 * После первой сделки трансформируется в asset dashboard
 * (см. docs/architecture/21-passport-owner-and-cabinet.md).
 *
 * Сейчас единственная рабочая фича — переключатель темы.
 * Roadmap-плашка убрана (не вводит в заблуждение).
 */

import { createFileRoute } from '@tanstack/react-router';
import { ThemeSwitcher } from '~/components/ThemeSwitcher';

export const Route = createFileRoute('/passport')({
  component: PassportPage,
});

function PassportPage() {
  return (
    <section
      className="min-h-full px-4 pb-8 pt-6"
      style={{ paddingTop: 'max(env(safe-area-inset-top), 24px)' }}
    >
      <header className="mb-6">
        <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-label-3">
          Tab 5
        </p>
        <h1
          className="mt-1 text-[34px] font-extrabold leading-tight tracking-[-0.8px] text-label"
          style={{ fontFamily: 'var(--font-display)' }}
        >
          Паспорт
        </h1>
        <p className="mt-1.5 text-[14px] font-semibold text-label-2">
          Дашборд активов появится после первой сделки
        </p>
      </header>

      <section className="mb-6">
        <h2 className="mb-2 px-1 text-[11px] font-bold uppercase tracking-[0.08em] text-label-2">
          Внешний вид
        </h2>
        <div
          className="rounded-3xl p-4 ring-1"
          style={{
            background: 'var(--color-glass-thin)',
            borderColor: 'var(--color-glass-stroke)',
          }}
        >
          <p className="mb-3 text-[14px] font-semibold text-label">
            Тема оформления
          </p>
          <ThemeSwitcher />
          <p className="mt-3 text-[11px] leading-snug text-label-3">
            «Авто» меняет тему вместе с системной — день светлая, ночь тёмная.
          </p>
        </div>
      </section>
    </section>
  );
}
